import { render, staticRenderFns } from "./ModalGiftCode.vue?vue&type=template&id=2916eafc&scoped=true&"
import script from "./ModalGiftCode.vue?vue&type=script&lang=js&"
export * from "./ModalGiftCode.vue?vue&type=script&lang=js&"
import style0 from "./ModalGiftCode.vue?vue&type=style&index=0&id=2916eafc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916eafc",
  null
  
)

export default component.exports